// Import global stylesheet
import './styles/main.scss';

// Import custom JS file
import './scripts/custom.js';